<template>
    <div class="material-box" v-loading="loading">
        <div class="material-content" v-if="!loading">
            <div class="top">
                <FormBox />
            </div>
            <template v-if="fileConfigList.length">
                <div class="idea-box mr10">
                    <div class="left">
                        <Material/>
                    </div>
                    <div class="right">
                        <SelectMaterial/>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="material-content">
                    <p class="ml20">不支持素材上传</p>
                </div>
            </template>
        </div>
        <div class="btns">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" @click="handleOnSubmit">保存</el-button>
        </div>
    </div>
</template>

<script>
import Material from './material.vue'
import SelectMaterial from './selectMaterial.vue'
import util from '@/libs/utils'
import { FILE_TYPE } from './constant'
import { TaskStore } from '@/utils/run-task'
import getMediaInfo from '@/libs/media';
import axios from 'axios';
import API from '@/api/marketManage/vivoBatch';
import { getMaterialInfoApi, getSearchConfigApi , genVideoCoverImg} from '@/api'
import FormBox from './formBox/index.vue'
import _ from 'lodash'
import COS from '@/libs/cos/Honor'
import { getPrimeNum} from '@/utils'
import {  observableMap } from './formBox/create.js'
import { tipModal } from '../index.js'
export default {
    props:[ 'cbs', 'appList', 'config', 'displayType', 'account', 'configOpt', 'defaultData', 'getMaterialNum' ],
    components: { Material, SelectMaterial, FormBox },
    provide(){
        return {
            global: this
        }
    },
    data() { 
        const displayTypeList = observableMap(this.displayType, (item)=> ({...item,num: 0,}))
		const appNumList = observableMap(this.appList, (item)=> ({...item,num: 0,}));
        const defaultData = this.defaultData || {};
        return {
            displayTypeList,
            appNumList,
            fileConfigList: [],
            appId: '',
            searchConfigData: {
                material_status_map: [],
                plat_map: [],
            },
            selectList: defaultData,
            uploadStore: new TaskStore(10),//文件上传
            addMaterialStore: new TaskStore(10),//添加素材
            uploadFileListCancelData: {},//取消上传文件
            currentKey: '',//当前表单key
            errFileList:[],//错误文件列表
            loading: false,
            ideaList: [],//素材列表
        }
    },
    computed: {
        noMaterialDisplayType() {
            const is_only_on_app_store = this.config.is_only_on_app_store;
            const list = is_only_on_app_store.filter((item)=> {
                return item.value == 1;
            });
            return _.keyBy(list, 'pid');
        }
    },
    created() {
        this.getWorkOrderSearchConfig();
        this.uploadStore.on('end', ()=> {
            this.showValidateFileErrorData();
        });
        this.getMaterialInfo()
    },
    methods: {
        formDataChange(acients, fileConfigList) {
            const key = acients.map(v=>v.payload.value).join('_');
            const oldKey = this.currentKey;
            // console.log(formData, 'formData');
          
			// 防止重复渲染
			if(this.currentKey === key ) {
				return;
			}
			this.currentKey = key;
            const oldFileConfigList = this.fileConfigList;
            this.fileConfigList =  fileConfigList.map((item)=> {
                return {
                    ...item,
                    format_text: `${item.ele_type_name}: 宽高(${item.conf_resolution})， 大小≤${item.file_size_kb_limit}，规格：${item.file_format}`,
                    id: _.uniqueId(),
                }
            });
            
            if(!fileConfigList.length) {
                this.selectList[key] = [ null ];
                this.updateFormOptionData()
                return;
            }
            this.updateFormOptionData()
            this.$nextTick(()=> {
                this.$bus.$emit('updateListData');
                const [ old_app_id ] = oldKey.split('_');
                const [ app_id ] = key.split('_');
                if(app_id !== old_app_id || !oldFileConfigList.length) {
                    const data = this.appList.find(v=>v.value == app_id);
                    this.$nextTick(()=> {
                        this.$bus.$emit('updataFormNameData', data?.app_name);
                    })
                }
            })
        },
        // 获取素材规格
        async getMaterialInfo() {
            try {
                this.loading = true;
                const params = {
                    plat_id: 11,
                    display_type: this.displayTypeList.map(v=>v.value).join(','),
                }
                const { data } = await getMaterialInfoApi(params);
                this.ideaList = data.map((item)=> {
                    return {
                        ...item,
                        ad_creative_list: observableMap(item.ad_creative_list, (item)=> {
                            return {
                                ...item,
                                value:item.ad_creative_spec_id,
                                label:item.ad_creative_spec_name,
                                num: 0,
                            }
                        })
                    }
                }) ;

                // this.fileConfigList = fileConfigList.map((item)=> {
                //     return {
                //         ...item,
                //         format_text: `${item.ele_type_name}: 宽高(${item.conf_resolution})， 大小≤${item.file_size_kb_limit}，规格：${item.file_format}`,
                //         id: _.uniqueId(),
                //     }
                // });
            } catch (error) {
                console.log(error, '获取素材规格失败');
                this.$message.error('获取素材规格失败');
            }finally {
                this.loading = false;
            }
        },
         // 验证文件
         async validateFile(file, configList) {
            const media  = await getMediaInfo(file);
            const ext = file.name.slice(file.name.lastIndexOf('.') + 1);
            
            const formatData = configList.reduce((pre, item)=> {
                pre.size.push(item.conf_size);
                const [ w, h] = item.conf_resolution.split('*');
                pre.wh.push([ w, h ]);
                if(item.conf_length) {
                    const [ min, max ] = item.conf_length.split('_');
                    pre.duration.push([ min, max ]);
                }
                pre.format.add(item.file_format)
                return pre;
            }, { size: [], wh: [], format: new Set(), duration: [] });
           
            const { duration, fileSize, height, width , format } = media;
            if (![...formatData.format].some(v=>v.indexOf(ext) >-1 )) {
                return Promise.reject({
                    name: file.name,
                    message: '素材格式不符合'
                });
            }
            // 验证大小
            if (!formatData.size.some(v=>fileSize < +v)) {
                return Promise.reject({
                    name: file.name,
                    message: '素材大小不符合'
                });
            }
            if( format === 'MPEG-4' && !formatData.duration.some(([ min, max ])=> {
                   return duration >= +min && duration <= +max
                })) {
                return Promise.reject({
                    name: file.name,
                    message: '素材时长不符合'
                });
            }
            if (!formatData.wh.some((wh)=>{
                const [ w, h] = wh;
                return height === +h && width === +w;
            })) {
                return Promise.reject({
                    name: file.name,
                    message: '素材尺寸不符合'
                });
            };
            // 统一验证
            const targetConfig = configList.find(item=> {
                const { conf_resolution } = item;
                return (
                    fileSize < +item.conf_size &&
                    (item.file_format.indexOf(ext) >-1)&&
                    ( !item.conf_length || ( item.conf_length && ( duration >= +item.conf_length.split('_')[0] && duration <= +item.conf_length.split('_')[1] ) ) )&&
                    `${width}*${height}` === conf_resolution
                );
            })
            if (!targetConfig) {
                return Promise.reject({
                    name: file.name,
                    message: '素材规格不符合'
                });
            }
            return { height, width, targetConfig } 
        },
         // 停止上传
         cancelUploadFile(key) {
            Object.values(this.uploadFileListCancelData).forEach(list=> {
                list.map(v=>v&&v())
            });
            this.uploadStore.stopAllTask()
        },
        // 提示验证失败的文件
        showValidateFileErrorData() {
            if (!this.errFileList.length) {
                return
            }
            const message = this.errFileList.map(v=> {
                return `<p>${v.name}</p><span>${v.message}</span>`
            })
            this.$notify.error({
                title: '错误',
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: `<div style="overflow-y: auto;max-height: 500px">${message.join('')}</div>`
            });
            this.errFileList = [];
        },
        async handleSelectData(check , data) {
            if (Array.isArray(data)) {
                data.forEach(item=> {
                    this.addMaterialStore.add(()=> this.handleSelectData(check, item))
                })
            }else {
                const coverId =  data.id;
                data.id = util.randomString(20);
                const dataList = this.selectList[data.key] || [];
                const type = data.config.ele_type;
                if (check) {
                    if(type === FILE_TYPE.COVER &&  (coverId)) {
                        // 自动生成
                        const findData = _.find(dataList, item=> item.id === coverId);
                        this.$set(findData, type, data);
                    }else {
                        const findData = _.find(dataList, item=> !item[type]);
                        if(findData) {
                            this.$set(findData, type, data)
                        }else {
                            dataList.push({
                                [type]: data,
                                id: util.randomString(20)
                            })
                        };
                    }
                   
                }else {
                    const findData = _.find(dataList, item=> data.id === item[type]?.id);
                    // 排除要删除的字段 和固定字段 后 判断是否需要保留当前数据
                    const length  = (_.keys(_.omit(findData, [
                        'id', 
                        type,
                        type ===FILE_TYPE.VIEDO? FILE_TYPE.COVER : ''
                    ]))).filter(v=>findData[v]).length;
                    if (length) {
                        this.$set(findData, type, null);
                        if(type ===FILE_TYPE.VIEDO ) {
                            this.$set(findData, FILE_TYPE.COVER, null);
                        }
                    }else {
                        const index = dataList.indexOf(findData);
                        if (index!== -1) {
                            dataList.splice(index, 1);
                        };
                    }
                }
                this.$set(this.selectList, data.key, dataList)
                this.updateFormOptionData();
                console.log(this.selectList, 'this.selectListthis.selectListthis.selectList');
            };
        },
      
        delAllCurAppData() {
            this.selectList[this.currentKey] = [];
            this.updateFormOptionData()
        },
        handleUploadFile(file, param) {
            const task = async ()=> {
                let cancel = null;
                
                try {
                    
                    const { targetConfig, width, height } = await this.validateFile(file, param.configList).catch((error)=> {
                        console.log(error, '文件验证出错');
                        
                        this.errFileList.push(error);
                        return false
                    });
                    const fileConfig = targetConfig;
                    if (!fileConfig) {
                        return
                    }
                    const result = await COS.putObject(file, {
                        onTaskReady: (id)=> {
                            let list = this.uploadFileListCancelData[file.key];
                            if (!list) {
                                list = this.uploadFileListCancelData[file.key] = []
                            }
                            list.push(cancel = id);
                        },

                    });
                    console.log(result, 'resultresult');
                    if(FILE_TYPE.VIEDO === fileConfig.ele_type) {
                        const params = {
                            video_url: result.path,
                            plat_id: '3',//固定传
                        }
                        const { data } = await genVideoCoverImg(params);
                        this.handleSelectData(true, {
                            ...result, key: file.key,config: fileConfig,
                            material_url: result.path, material_name: result.name,
                            full_material_url: result.full_path,
                            img_full_material_url: data.fullFilePath,
                            img_material_url: data.filePath,
                            width, height
                        })
                    }else {
                        this.handleSelectData(true, {
                            ...result, key: file.key,config: fileConfig,
                            material_url: result.path, material_name: result.name,
                            full_material_url: result.full_path,
                            img_full_material_url: result.full_path
                        })
                    }
                    
                    // this.handleSelectData(true, {
                    //     ...result, key: file.key,config: fileConfig,
                    //     material_url: result.path, material_name: result.name,
                    //     full_material_url: result.full_path,
                    //     img_full_material_url: result.full_path
                    // })
                } catch (error) {
                    console.log(error, '上传出错');
                    this.$message.error(error.info)
                }finally {
                    const list = this.uploadFileListCancelData[file.key] || []
                    const index = list.indexOf(cancel);
                    if (index !== -1) {
                        list.splice(index, 1);
                    };
                }
            };
            this.uploadStore.add(task);
        },
        async getWorkOrderSearchConfig() {
            const { data } = await getSearchConfigApi();
            this.searchConfigData = data;
        },
        async validateFn() {
            /**
             * empty  版位素材为空
             * required. 存在必填的素材
             */
            const errorDataList = { empty: [], required: [] }; 
            this.appList.forEach((item)=> {
                this.displayType.forEach((item2)=> {
                    const ideaList = this.ideaList.find(v=>v.ad_placement_id == item2.value);
                    if(this.noMaterialDisplayType[item2.value]){
                        return;
                    }
                    const hasData = ideaList.ad_creative_list.some((item3)=> {
                        const key = `${item.value}_${item2.value}_${item3.value}`;
                        const list = this.selectList[key] || [];
                        return !!list.length;
                    })
                    if(!hasData) {
                        errorDataList.empty.push(`${item.app_name} - ${item2.label}`);
                        return;
                    }
                    ideaList.ad_creative_list.forEach((item3)=> {
                        const key = `${item.value}_${item2.value}_${item3.value}`;
                        const list = this.selectList[key] || [];
                        const hasData = list.every((v1)=> {
                            return item3.ele_list.every((v2)=> {
                                return v1[v2.ele_type]
                            });
                        });
                        if(!hasData) {
                            errorDataList.required.push(`${item.app_name} - ${item2.label}- ${item3.label}`)
                        };
                    })
                })
            });
            if(errorDataList.empty.length || errorDataList.required.length) {
                return Promise.reject(errorDataList);
            }else {
                return true;
            }
        },
        async handleOnSubmit() {
            try {
                await this.validateFn();
                this.cbs.onSubmit(this.selectList);
            } catch (error) {
                console.log(error, 'error');
                
                const { empty, required } = error;
                const tipData = {}
                if(empty.length) {
                	tipData['存在为空的素材']=empty
                };
                if(required.length) {
                	tipData['存在必填的素材']=required
                };
                tipModal({
                    props: {
                        tip: '',
                        list: tipData
                    },
                })
            }
        },
        // 更新表单选项数据
        updateFormOptionData() {
            const [ app_id, display_type ] = this.currentKey.split('_');
            const keys = Object.keys(this.selectList);
            this.appNumList.forEach(v=>{
                v.num = keys.reduce((pre, item)=> {
                    const [ app_id , display_type ] = item.split('_');
                    if(app_id === v.value) {
                        pre += this.selectList[item].length;
                    }
                    return pre;
                }, 0);
            });
            this.displayTypeList.map(v=>{
                v.num = keys.reduce((pre, item)=> {
                    const [ appId, display_type ] = item.split('_');
                    if(display_type === v.value && appId === app_id) {
                        pre += this.selectList[item].length;
                    }
                    return pre;
                }, 0);
            });
            const ideaList = this.ideaList.find(v=>v.ad_placement_id == display_type);
            ideaList.ad_creative_list.forEach(v=>{
                const key = `${app_id}_${display_type}_${v.value}`;
                v.num = this.selectList[key]?.length || 0;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.material-box {
    height: 100%;
    
    display: flex;
    flex-direction: column;
}
.material-content {
    flex: 1;
    overflow: auto;
}
.btns {
    padding: 20px 80px 20px 0;
    text-align: right;
    border-top: 1px solid #E4E7ED;
}
.idea-box {
    position: relative;
    border: 1px solid #E4E7ED;
    display: flex;
    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 38px;
        border: 2px solid #E4E7ED;
    }
   
    .left {
        flex: 1;
    }
    .right {
        width: 500px;
    }
}
</style>